export default import.meta.ROLLDOWN_FILE_URL_YIZqdzaNCc34R5f11T8Rpw